import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { createInquiry } from './myPageApi';

// 문의 등록 화면: 제목·내용을 입력받아 등록하고, 성공하면 문의 조회로 이동한다.
export default function InquiryFormSection() {
    const navigate = useNavigate();
    const [values, setValues] = useState({ title: '', content: '' });
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const formValid = values.title.trim() && values.content.trim();

    // 입력란 변경 값을 상태에 반영한다.
    function change(event) {
        const { name, value } = event.target;
        setValues(previous => ({ ...previous, [name]: value }));
    }

    // 문의를 등록하고 문의 조회 화면으로 보낸다.
    async function submit(event) {
        event.preventDefault();
        if (!formValid || submitting) return;
        setSubmitting(true);
        setError('');
        try {
            await createInquiry({ title: values.title.trim(), content: values.content.trim() });
        } catch (submitError) {
            setError(submitError.message);
            setSubmitting(false);
            return;
        }
        window.alert('문의를 등록했습니다. 답변이 등록되면 문의 조회하기에서 확인할 수 있습니다.');
        navigate('/mypage/inquiry');
    }

    return <>
        <div className="my-page-section-heading"><div><h2>문의 등록하기</h2><p>서비스 이용 중 궁금한 점을 남겨주세요.</p></div></div>
        <form className="my-page-card my-page-form" onSubmit={submit} noValidate>
            <label><span>제목</span><input type="text" name="title" value={values.title} onChange={change} disabled={submitting} required /></label>
            <label><span>내용</span><textarea name="content" value={values.content} onChange={change} disabled={submitting} required rows={8} /></label>
            <p className="my-page-notice">답변이 등록되면 가입하신 이메일로 답변 완료 메일을 보내드려요.</p>
            {error && <p className="my-page-field-error" role="alert">{error}</p>}
            <div className="my-page-form-actions"><button type="submit" className="my-page-button primary" disabled={!formValid || submitting}>{submitting ? '등록 중…' : '문의 등록'}</button></div>
        </form>
    </>;
}
